/**
 * Maps report key/category → lucide icon. Single source of truth so the
 * landing page and viewer page agree on which icon belongs to which report.
 *
 * Adding a new report? Add an entry to `REPORT_ICONS`. Unknown keys fall
 * back to the category icon, then to `FileBarChart`.
 */

import {
  FileBarChart,
  Package,
  Receipt,
  ShoppingCart,
  UserPlus,
  Users,
  Wallet,
  type LucideIcon,
} from "lucide-react";

/** Per-report-key icons. Empty = use the category icon. */
const REPORT_ICONS: Record<string, LucideIcon> = {
  "employee-list": Users,
  "joiners-report": UserPlus,
  // Future report keys land here.
};

/** Per-category icons. Used as fallback when a report has no specific icon. */
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  sales: Receipt,
  purchases: ShoppingCart,
  cash: Wallet,
  inventory: Package,
  payroll: Users,
  general: FileBarChart,
};

export function iconForReport(key: string, category: string): LucideIcon {
  return REPORT_ICONS[key] ?? CATEGORY_ICONS[category] ?? FileBarChart;
}

export function iconForCategory(category: string): LucideIcon {
  return CATEGORY_ICONS[category] ?? FileBarChart;
}
